import { Plugin } from 'ckeditor5/src/core';
import GFMDataProcessor from './gfmdataprocessor';

export default class Markdown extends Plugin {
	constructor( editor ) {
		super( editor );

		editor.data.processor = new GFMDataProcessor( editor.data.viewDocument, editor.config.get( "markdown" ).markdown2html );
	}

	static get pluginName() {
		return 'Markdown';
	}
}
